import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import { useAppDispatch, useAppSelector } from '../../../../../app/config/store';
import {
  Button,
  Card,
  Col,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Form,
  FormFeedback,
  FormGroup,
  Input,
  Label,
  Row,
  Spinner,
} from 'reactstrap';
import { createForms, saveForms } from '../../entities/case-forms/case-forms.reducer';
import { useNavigate } from 'react-router';
import { createLawyerForms } from '../../entities/case-forms/case-lawyer.reducer';
import { getAiChatId } from '../../entities/case-review/case-review.reducer';
import Stepperform from '../../shared/layout/stepperform/stepperform';
import FooterComponent from '../../shared/layout/footer/footer';
import { Skeleton } from './skeleton';
const CaseQuestionaire = () => {
  const dispatch = useAppDispatch();
  const [dropdownStates, setDropdownStates] = useState({});
  // const list = useAppSelector(state => state.caseForm.entities);
  const { entities, loading } = useAppSelector(state => state.caseForm);
  const { id } = useAppSelector(state => state.authentication?.account);
  const { entity } = useAppSelector(state => state.caseLawyer);
  const [errors, setErrors] = useState<any>({});
  const [formData, setFormData] = useState<any>([]);
  const [loader, setLoader] = useState<boolean>(false);
  const [skeleton, setShowSkeleton] = useState<boolean>(false);
  const [formValues, setFormValues] = useState<any>({});
  const get_ai_id: any = localStorage.getItem('ai_id');
  const [saveMessage, setSaveMessage] = useState<any>('');
  const navigate = useNavigate();
  const initalAiId = JSON.parse(get_ai_id);

  const getAIChatId = async () => {
    try {
      // const requestUrl = `api/workflows/${process.env.IS_DEV ? '4716' : '4911'}/start?extRefKey=${id}`;
      const requestUrl = `api/workflows/4911/start?extRefKey=${id}`;

      const response = await axios.get(requestUrl);
      if (response?.data) {
        localStorage.setItem('ai_id', JSON.stringify(response?.data?.data));
        getforms(response?.data?.data);
      } else {
        setShowSkeleton(false);
      }
    } catch (error) {
      setShowSkeleton(false);
    }
  };

  const getforms = async (id: any) => {
    try {
      await dispatch(createForms(id));
      setShowSkeleton(false);
    } catch (error) {
      setShowSkeleton(false);
      console.error('Failed to fetch chat ID:', error);
    } finally {
      setShowSkeleton(false);
    }
  };

  useEffect(() => {
    setShowSkeleton(true);
    const timeoutId = setTimeout(() => {
      getAIChatId();
    }, 1000);

    return () => clearTimeout(timeoutId);

    // const fetchChatId = async () => {
    //   setShowSkeleton(true);
    //   // if (!initalAiId) {
    //   try {
    //     await dispatch(getAiChatId(id));
    //   } catch (error) {
    //     setShowSkeleton(false);
    //     console.error('Failed to fetch chat ID:', error);
    //   }
    // };
    // // };

    // fetchChatId();
  }, [id, dispatch]);

  const getformFields = () => {
    const initialValues = {};

    entities?.forEach(field => {
      initialValues[field.name] = field.value || '';
    });
    setFormValues(initialValues);
    setFormData(entities || []);
  };

  // useEffect(() => {
  //   initalAiId && getforms();
  // }, [initalAiId]);

  useEffect(() => {
    getformFields();
    setSaveMessage('');
  }, [entities]);

  const handleChange = e => {
    const { name, value } = e.target;
    setFormValues(prevValues => ({
      ...prevValues,
      [name]: value,
    }));
  };

  const handleSelect = (name, selectedOption) => {
    setFormValues(prevValues => ({
      ...prevValues,
      [name]: selectedOption,
    }));
  };

  const handleMutliSelect = (name, selectedOption) => {
    setFormValues(prev => {
      const currentStr = prev[name] || '';
      const currentArr = currentStr ? currentStr.split(',') : [];

      const updatedArr = currentArr.includes(selectedOption)
        ? currentArr.filter(item => item !== selectedOption)
        : [...currentArr, selectedOption];

      return {
        ...prev,
        [name]: updatedArr.join(','),
      };
    });
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setShowSkeleton(true);

    const formList = formData.map(field => ({
      name: field.name,
      value: formValues[field.name] || '',
      type: field.type,
      formInputType: field.formInputType,
      options: field.options || null,
    }));
    setLoader(true);
    setSaveMessage('Please wait, we are saving your information...');
    await dispatch(saveForms({ initalAiId, formList })).then((mes: any) => {
      toast.success(mes?.payload?.data?.message, {
        position: 'top-right',
      });

      const currentStep = 1;
      const submittedStr = localStorage.getItem('submittedstep');
      const submitted = submittedStr ? JSON.parse(submittedStr) : {};

      if (id) {
        const steps = submitted[id] || [];
        if (!steps.includes(currentStep)) {
          steps.push(currentStep);
          submitted[id] = steps;
          localStorage.setItem('submittedstep', JSON.stringify(submitted));
          localStorage.setItem('step', JSON.stringify(2));
        }
      }

      entity?.data && dispatch(createLawyerForms(entity?.data));
      navigate('/step-2');
      setShowSkeleton(false);
    });
    setLoader(false);
  };

  // const handleSubmit = async e => {
  //   e.preventDefault();
  //   setShowSkeleton(true);
  //   const formList = formData.map(field => ({
  //     name: field.name,
  //     value: formValues[field.name] || '',
  //     type: field.type,
  //     formInputType: field.formInputType,
  //     options: field.options || null,
  //   }));
  //   setLoader(true);
  //   setSaveMessage('Please wait, we are saving your information...');
  //   await dispatch(saveForms({ initalAiId, formList })).then((mes: any) => {
  //     toast.success(mes?.payload?.data?.message, {
  //       position: 'top-right',
  //     }),
  //      sessionStorage.setItem('savedSteps', JSON.stringify([1]));
  //      localStorage.setItem('step', JSON.stringify(2));
  //     localStorage.setItem('submitted', JSON.stringify([1]));
  //     entity?.data && dispatch(createLawyerForms(entity?.data));
  //     navigate('/step-2');
  //     setShowSkeleton(false);
  //   });
  //   setLoader(false);
  // };

  const toggleDropdown = fieldName => {
    setDropdownStates(prevState => ({
      ...prevState,
      [fieldName]: !prevState[fieldName],
    }));
  };

  return (
    <>
      <div className="main-content flex-grow-1 d-flex flex-column gap-5 justify-content-between px-4 pb-4">
        <div className="custom-container flex-grow-1">
          <h1 className="page-title">Case Details Form</h1>
          <Stepperform />
          <Card className="card-wrapper">
            <div className="form_wrapper">
              <h3 className="form-title">Initial screening questions</h3>
              <p> Complete the questions below</p>
              {!skeleton ? (
                <Form onSubmit={handleSubmit}>
                  <Row>
                    {
                      formData
                        ?.filter(field => field.displayNumber !== null && field.displayNumber !== undefined)
                        ?.sort((a, b) => a.displayNumber - b.displayNumber)
                        ?.reduce(
                          (acc, field, index, arr) => {
                            if (field.formInputType === 'DATE') {
                              // Allow up to two date fields in the same row
                              if (acc.tempDateFields.length < 2) {
                                acc.tempDateFields.push(field);
                              }

                              // If two date fields are collected OR it's the last field, create a row
                              if (acc.tempDateFields.length === 2 || index === arr.length - 1) {
                                acc.rows.push(
                                  <Col lg="6" key={`date-row-${index}`} className="mb-3">
                                    <Row>
                                      {acc.tempDateFields.map(dateField => (
                                        <Col md="6" key={dateField.name}>
                                          <FormGroup className="position-relative">
                                            <Label for={dateField.name}>
                                              {dateField.name.charAt(0).toUpperCase() + dateField.name.slice(1)}
                                            </Label>
                                            <Input
                                              type="date"
                                              name={dateField.name}
                                              id={dateField.name}
                                              value={formValues[dateField.name]}
                                              invalid={!!errors[dateField.name]}
                                              onChange={handleChange}
                                              style={{ cursor: 'pointer' }}
                                              max={new Date().toISOString().split('T')[0]}
                                            />
                                            <FormFeedback>{errors[dateField.name]}</FormFeedback>
                                          </FormGroup>
                                        </Col>
                                      ))}
                                    </Row>
                                  </Col>,
                                );
                                acc.tempDateFields = [];
                              }
                            } else {
                              // Process other field types as per formInputType
                              acc.rows.push(
                                <Col lg="6" key={index} className="mb-3">
                                  <FormGroup className="position-relative">
                                    <Label for={field.name}>{field.name.charAt(0).toUpperCase() + field.name.slice(1)}</Label>
                                    {field.formInputType === 'TEXTAREA' ? (
                                      <Input
                                        type="textarea"
                                        name={field.name}
                                        style={{ resize: 'none' }}
                                        id={field.name}
                                        placeholder="If applicable, please describe any incidents including dates."
                                        value={formValues[field.name]}
                                        onChange={handleChange}
                                        invalid={!!errors[field.name]}
                                      />
                                    ) : field.formInputType === 'SELECT' ? (
                                      <Dropdown isOpen={dropdownStates[field.name] || false} toggle={() => toggleDropdown(field.name)}>
                                        <DropdownToggle caret className="dropdown-toggle-custom">
                                          {formValues[field.name] ? formValues[field.name] : 'Select'}
                                        </DropdownToggle>
                                        <DropdownMenu className="custom-dropdown">
                                          {field.options?.split(',').map((option, optIndex) => (
                                            <DropdownItem
                                              key={optIndex}
                                              value={option}
                                              className={`custom-option ${formValues[field.name] === option ? 'selected-option' : ''}`}
                                              onClick={() => handleSelect(field.name, option)}
                                            >
                                              {option}
                                            </DropdownItem>
                                          ))}
                                        </DropdownMenu>
                                      </Dropdown>
                                    ) : field.formInputType === 'MULTISELECT' ? (
                                      <Dropdown isOpen={dropdownStates[field.name] || false} toggle={() => toggleDropdown(field.name)}>
                                        <DropdownToggle caret className="dropdown-toggle-custom multi-select-toggle">
                                          {formValues[field.name]?.length ? formValues[field.name] : 'Select Multiple'}
                                        </DropdownToggle>
                                        <DropdownMenu className="custom-dropdown">
                                          {field.options?.split(',').map((option, optIndex) => {
                                            const selectedValues = formValues[field.name]?.split(',') || [];
                                            const isSelected = selectedValues.includes(option);
                                            return (
                                              <DropdownItem
                                                key={optIndex}
                                                value={option}
                                                onClick={() => handleMutliSelect(field.name, option)}
                                                className={`custom-option ${isSelected ? 'selected-option' : ''}`}
                                              >
                                                {option}
                                              </DropdownItem>
                                            );
                                          })}
                                        </DropdownMenu>
                                      </Dropdown>
                                    ) : // <Input
                                    //   type="select"
                                    //   name={field.name}
                                    //   id={field.name}
                                    //   value={formValues[field.name]}
                                    //   onChange={handleChange}
                                    //   invalid={!!errors[field.name]}
                                    // >
                                    //   <option value="">Select</option>
                                    //   {field.options?.split(',').map((option, optIndex) => (
                                    //     <option key={optIndex} value={option}>
                                    //       {option}
                                    //     </option>
                                    //   ))}
                                    // </Input>

                                    field.formInputType === 'RADIO' ? (
                                      field.options?.split(',').map((option, optIndex) => (
                                        <div key={optIndex} className="form-check">
                                          <Input
                                            type="radio"
                                            name={field.name}
                                            id={`${field.name}-${option}`}
                                            value={option}
                                            checked={formValues[field.name] === option}
                                            onChange={handleChange}
                                            className="form-check-input"
                                            invalid={!!errors[field.name]}
                                          />
                                          <Label for={`${field.name}-${option}`} className="form-check-label">
                                            {option}
                                          </Label>
                                        </div>
                                      ))
                                    ) : (
                                      <Input
                                        type={field.type.toLowerCase()}
                                        name={field.name}
                                        id={field.name}
                                        placeholder="If applicable, please describe any incidents including dates."
                                        value={formValues[field.name]}
                                        onChange={handleChange}
                                        invalid={!!errors[field.name]}
                                      />
                                    )}
                                    <FormFeedback>{errors[field.name]}</FormFeedback>
                                  </FormGroup>
                                </Col>,
                              );
                            }

                            return acc;
                          },
                          { rows: [], tempDateFields: [] },
                        ).rows
                    }
                  </Row>
                  {formData?.length == 0 && <> No Data Found</>}
                  {formData?.length > 0 ? (
                    <div className="d-flex align-items-center justify-content-between">
                      <Button className="theme-button" type="submit" disabled={loader}>
                        {loader ? <Spinner size="sm">Loading...</Spinner> : 'Next'}
                      </Button>
                    </div>
                  ) : null}
                </Form>
              ) : (
                // <div style={{ justifyItems: 'center', alignItems: 'center', left: 0, top: 0, position: 'relative', display: 'grid', height: "50%" }}>
                //   <Spinner>Loading...</Spinner>
                // </div>
                <Skeleton message={saveMessage} />
              )}
            </div>
          </Card>
        </div>
        <FooterComponent />
      </div>
    </>
  );
};

export default CaseQuestionaire;
